'use client';

import { usePathname } from 'next/navigation';

import { asideHeadCallToActionCentered } from '@/app/[locale]/(new)/(public)/projects/[slug]/_page.css';
import { CallToAction } from '@/app/_componentsv2/call-to-action';
import Routes from '@/lib/router/routes';

export function AnonymousNavigationSignIn() {
  const pathname = usePathname();

  const searchParams =
    pathname !== Routes.Home
      ? `?${new URLSearchParams({ origin: pathname }).toString()}`
      : '';

  return (
    <CallToAction
      label="Investir"
      className={asideHeadCallToActionCentered}
      type="next"
      href={`${Routes.SignIn}${searchParams}`}
      hasArrow={true}
    />
  );
}
